module.exports = __webpack_public_path__ + "03_mustache_grey.a2ee065d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/03_mustache_grey.png
// module id = gCqw
// module chunks = 0